import Store from "@/store";
import clear_all_videos from "@/router/modules/methods/clear_all_videos";

export default {
    path: '/add-video',
    name: 'Add-Video',
    meta: {
        title: 'Выбор видео',
        forVisitors: true
    },
    component: () => import(`~/views/add_video/index.vue`),
    beforeEnter: async(to, from, next) => {
        await clear_all_videos()
        if(Store.getters['edit/editableItem']) {
            next()
        } else if(Store.getters['entry_video/entry'].length > 0){
            if(Store.getters['edit/control'] === 'entry') {
                next({ name: 'Video-Editor' })
            } else {
                next()
            }
        } else {
            next({ name: 'Theme'})
        }
    }
}